import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class InputWrapper extends React.Component {
  handleChange = event => {
    this.props.onChange(this.props.input, event.target.value);

    if (this.props.xtraOnChange) this.props.xtraOnChange();
  }

  onBlur = () => {
    if (this.props.onBlur) this.props.onBlur();
  }

  render() {
    let errors = this.props.input.validations.errors.map(e => e);
    const inputClass = classNames({
      'editing': this.props.editing && !this.props.disabled,
      'error': this.props.input.validations.errors.length > 0 && !this.props.disabled
    });

    return <div onBlur={this.onBlur} style={this.props.style.wrapper || null}>
      <input type={this.props.type || "text"}
        id={this.props.id}
        placeholder={this.props.placeholder}
        value={this.props.input.validations.val}
        onBlur={() => (!this.props.disabled && this.props.blurValidate) && this.props.valid(this.props.input)}
        onKeyUp={this.props.onKeyDown && this.props.onKeyDown}
        onChange={this.handleChange}
        tabIndex={this.props.tabOrder}
        className={inputClass}
        maxLength={this.props.maxLength && this.props.maxLength}
        autoFocus={this.props.autoFocus}
        disabled={this.props.disabled}
        style={this.props.style.input}
        />

      {errors.length > 0 && <div className="error">
        <ul>
          {errors.map((e, i) => e.message !== '' && <li key={i} className="error">
            {e.message}
          </li>)}
        </ul>
      </div>}
    </div>;
  }
}

InputWrapper.defaultProps = {
  blurValidate: true,
  style: {
    wrapper: null,
    input: null
  }
}

InputWrapper.PropTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  valid: PropTypes.func,
  validations: PropTypes.func,
  tabOrder: PropTypes.string,
  editing: PropTypes.bool,
  defaultValue: PropTypes.string,
  style: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Wrappers/InputWrapper.js